<template>
    <div>
       
        <img src="" /><a @click="inImageUpload = true" style="cursor:pointer !important;">Upload</a>
    </div>
</template>

<script>

export default {
    data() {
        return {
            inImageUpload: false
        };
    },
    methods: {
        successUpload(){
            alert('Cool!');
        }
    }
};
</script>